import { publicConfig } from "@lululemon/ecom-core";

const CLIENT_ID = "lls";
const OPTIONS = { autoCalculate: false };

const hasWindow = typeof window !== "undefined";
const ENVIRONMENT = publicConfig?.trueFit?.environment;

/* eslint-disable */
export const trueFitScript = () => hasWindow
?
/* This code is taken from TrueFit SDK */
(function(){
var a={};
function g(l){
a[l]=function(r,e,o){
var w=window,d=document,p=[],t,s,x;
w.tfcapi=t=w.tfcapi||function(){
t.q=t.q||[];
t.q.push(arguments);};
o && !!o.deviceType && p.push('deviceType=' + o.deviceType);
o&&o.autoCalculate===false&&p.push('autoCalculate=false');
x=d.getElementsByTagName('script')[0];
s=d.createElement('script');
s.type='text/javascript';s.async=true;
s.src='https://'+r+'-cdn'+(e==='dev'||e==='staging'?'.'+e:'')+ '.truefitcorp.com/fitrec/'+r+'/js/'+l+'.js?'+p.join('&');
x.parentNode.insertBefore(s,x);}}
g('fitrec');
g('tracker');
return a;
// Don't change anything above this line
})().fitrec(CLIENT_ID,ENVIRONMENT,OPTIONS)
/* End TrueFit code */
: () => {};

